import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function payments() {
    return {
        index,
        get,
        getMultiPay,
        createPayment,
        createMultiPayments,
        deletePayment,
        verifyPayment
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null,
            bill: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`bill-pay/search${params}`);
    }

    function get(paymentsId) {
        return axiosInstance.get(`bill-pay/get?id=${paymentsId}`);
    }

    function deletePayment(id) {
        return axiosInstance.delete(`bill-pay/delete`, {
            data: {
                id: id
            }
        });
    }

    function createPayment(payload) {
        if (payload.id) {
            return axiosInstance.patch('bill-pay/update', payload);
        } else {
            const formData = new FormData();

            formData.append('bill', payload.bill);
            formData.append('payDate', payload.payDate);
            formData.append('amount', payload.amount);
            formData.append('currency', payload.currency);
            formData.append('paidType', payload.paidType);
            formData.append('account', payload.account);
            formData.append('conversion', payload.conversion);
            formData.append('referenceNumber', payload.referenceNumber);
            formData.append('note', payload.note);
            formData.append('verified', payload.verified || false);

            formData.append('document', payload.document);

            return axiosInstance.post('bill-pay/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }

    function createMultiPayments(payload) {
        const formData = new FormData();

        formData.append('customer', payload.customer);
        formData.append('referenceNumber', payload.referenceNumber);
        formData.append('paidType', payload.paidType);
        formData.append('payDate', payload.payDate);
        formData.append('amount', payload.amount);
        formData.append('verified', true);
        formData.append('account', payload.account);
        formData.append('conversion', payload.conversion);
        formData.append('currency', payload.currency);
        formData.append('document', payload.document);

        payload.invoices.forEach((invoice, index) => {
            formData.append(`bills[${index}][id]`, invoice.id);
            formData.append(`bills[${index}][amount]`, invoice.amount);
        });

        return axiosInstance.post('multipay/create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function getMultiPay(id) {
        return axiosInstance.get(`multipay/get?id=${id}`);
    }

    function verifyPayment(id) {
        return axiosInstance.post('bill-pay/verify-payment', { id });
    }
}
